import { Col, Row, Typography } from 'antd';

interface PercentageComparisonProps {
  comparison: number;
  enabled: boolean;
}

const PercentageComparison = ({ comparison, enabled }: PercentageComparisonProps) => {
  return (
    <>
      <Row style={{ height: 30 }}>
        <Col span={18}>
          <Row style={{ height: 30 }} justify="center" align="middle">
            {enabled && <Typography.Text style={{ fontSize: 14 }}>{comparison}%</Typography.Text>}
          </Row>
        </Col>
      </Row>
    </>
  );
};

export default PercentageComparison;
